<template>
    <div class="form-group custom-control custom-checkbox large" :class="{ 'agree-tou': true, 'has-error': hasError }">
        <label class="checkbox" for="agreeTou">
            <input
                id="agreeTou"
                type="checkbox"
                class="checkbox custom-control-input"
                :class="{
                    disabled: disabled,
                }"
                :name="name"
                :disabled="disabled"
                :checked="value"
                @change="$emit('input', $event.target.checked)"
            />

            <span class="input-check"></span>

            <i18n
                :path="`account.${isMarketing ? 'marketing-' : ''}agree-tou-creation`"
                tag="span"
                class="checkbox-label"
            >
                <template v-slot:touLink>
                    <a id="touAccept" data-cy="link-terms" :href="touUrl" target="_blank" rel="external">{{
                        $t('account.tou')
                    }}</a>
                </template>
                <template v-slot:privacyLink>
                    <a id="privacyAccept" data-cy="link-privacy" :href="privacy" target="_blank" rel="external">{{
                        $t('account.privacy')
                    }}</a>
                </template>
            </i18n>
        </label>
    </div>
</template>

<script>
import legalLinks from '@/config/terms-link';

export default {
    name: 'TermsCheckboxCreation',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        name: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        hasError: {
            type: Boolean,
            default: false,
        },
        inlineErrorText: {
            type: String,
            default: '',
        },
        isMarketing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        touUrl() {
            if (this.region === 'one') {
                return `/account/${this.$route.params.locale}/global/terms-of-use`;
            }
            return legalLinks[this.region].tou.replace('{locale}', this.$i18n.locale);
        },
        privacy() {
            if (this.region === 'one') {
                return `/account/${this.$route.params.locale}/global/privacy-policy`;
            }
            return legalLinks[this.region].privacy.replace('{locale}', this.$i18n.locale);
        },
    },
    methods: {},
};
</script>

<style lang="less" scoped>
label {
    font-size: 12px;
}
</style>
